import { put, select, takeEvery } from 'redux-saga/effects';
import { ActionType } from 'typesafe-actions';

import { IResponseError } from 'APIPackage/MainModule/interfaces/IResponseError';
import { catalogGet, catalogKnmInspectorsGetById } from 'CorePackage/CatalogsModule/actions/catalogsActions';
import { CommonCatalogsNamesEnum } from 'CorePackage/CatalogsModule/enums/CommonCatalogsNamesEnum';
import { fetchKnmInspectorsUpdate } from 'APIPackage/KnmModule/services/knmInspectorsApi';
import { addNoticeAction } from 'CorePackage/NotificationModule/actions/NoticeActions';
import { MessageTypesEnum } from 'CorePackage/NotificationModule/enums/MessageTypesEnum';
import { NoticeTypesEnum } from 'CorePackage/NotificationModule/enums/NoticeTypesEnum';
import { changePassword } from 'APIPackage/AccountModule/services/userSettingsApi';
import { IChangePasswordError } from 'APIPackage/AccountModule/interfaces/IChangedPasswordError';
import { getAccountDefaultKnoOrganizationId } from 'CorePackage/AccountModule/selectors/accountSelectors';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { sagaWrapper } from 'CorePackage/MainModule/common/sagaWrapper';
import { checkObjWithNameProp } from 'CorePackage/MainModule/common/checkObjWithNameProp';

import { personalAccountUpdateKnmInspectors, personalAccountUpdatePassword } from '../actions/personalAccountAction';
import { PersonalAccountActionsEnum } from '../enums/PersonalAccountActionsEnum';

export function* watchPersonalAccountSaga() {
  yield takeEvery(PersonalAccountActionsEnum.PERSONAL_ACCOUNT_GET_KNM_INSPECTORS, personalAccountGetKnmInspectorsSaga);
  yield takeEvery(
    PersonalAccountActionsEnum.PERSONAL_ACCOUNT_UPDATE_KNM_INSPECTORS,
    personalAccountUpdateKnmInspectorsSaga,
  );
  yield takeEvery(PersonalAccountActionsEnum.PERSONAL_ACCOUNT_UPDATE_PASSWORD, personalAccountUpdatePasswordSaga);
}

function* personalAccountGetKnmInspectorsSaga() {
  yield put(catalogGet(CommonCatalogsNamesEnum.KNM_INSPECTOR_TYPES));
}

function* personalAccountUpdateKnmInspectorsSaga(action: ActionType<typeof personalAccountUpdateKnmInspectors>) {
  function* funcTry() {
    const { data, organizationId } = action.payload;
    const state: IRootState = yield select();
    const defaultId = getAccountDefaultKnoOrganizationId(state);
    const currentId = organizationId || defaultId;

    yield fetchKnmInspectorsUpdate({
      knoId: currentId || '',
      inspectors: currentId ? data.map(item => ({ ...item, knoOrganizationId: currentId })) : data,
    });
    yield put(catalogKnmInspectorsGetById(currentId));
  }

  yield sagaWrapper({
    funcTry,
    *funcCatch(error: IResponseError) {
      yield put(
        addNoticeAction({
          renderContent: error.text,
          noticeType: NoticeTypesEnum.ERROR,
          messageType: MessageTypesEnum.KNM_INSPECTORS,
        }),
      );
    },
  });
}

function* personalAccountUpdatePasswordSaga(action: ActionType<typeof personalAccountUpdatePassword>) {
  yield sagaWrapper({
    *funcTry() {
      const { params } = action.payload;

      yield changePassword(params);
      yield put(
        addNoticeAction({
          renderContent: 'Пароль успешно изменен',
          noticeType: NoticeTypesEnum.SUCCESS,
          messageType: MessageTypesEnum.PASSWORD_CHANGE,
        }),
      );
    },
    *funcCatch(err: IResponseError) {
      if (checkObjWithNameProp<IChangePasswordError>(err, 'userMessage')) {
        yield put(
          addNoticeAction({
            renderContent: err.userMessage,
            noticeType: NoticeTypesEnum.ERROR,
            messageType: MessageTypesEnum.PASSWORD_CHANGE,
          }),
        );
      }
    },
  });
}
